<template>

  <div id="dlnkaap_admin_jury">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <dlnkwait :wait_data="wait_data"></dlnkwait>

    <!-- Modal Note du jury -->
    <div class="modal fade" id="notes_modal" tabindex="-1" role="dialog" aria-labelledby="notes_modalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notes_modalLabel">Notes du jury projet</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <p class="text-muted">{{current_aap.projet_nom}}</p>

            <ckeditor :editor="editor" :config="editor_config" name="description" v-model="note_jury">
            </ckeditor>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Annuler</button>
            <button type="button" class="btn btn-primary" @click="set_note()">Sauvegarder</button>
          </div>
        </div>
      </div>
    </div>


    <!-- ========== MAIN ========== -->
    <main id="content" role="main" class="bg-light">
      <!-- Breadcrumb Section -->
      <div class="bg-primary" style="background-image: url(/themes/template/img/components/abstract-shapes-20.svg);">
        <div class="container space-1 space-top-lg-2 space-bottom-lg-3">
          <div class="row d-flex justify-content-between px-3">
            <h2 class="text-white my-auto col-6">Appels à projet : admin jury</h2>

            <div class="col-6 my-auto">
              <h3 class="text-white text-right">Montant total : <span class="badge badge-success">{{ montant_total }}€</span></h3>
              <h3 class="text-white text-right">Montant restant : <span class="badge badge-secondary">{{ montant_restant }}€</span></h3>
            </div>
          </div>
        </div>
      </div>
      <!-- End Breadcrumb Section -->

      <!-- Content Section -->
      <div class="container-fluid space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10 mx-auto">
        <div class="row">

          <div class="col-12">
            <!-- Card -->
            <div class="card">
              <div class="card-header d-flex justify-content-between align-items-center py-2
                          flex-column flex-lg-row">
                <h4 class="card-header-title mb-2 mb-lg-0">Liste des appels</h4>
                <div class="d-inline-flex">
<!--                    <div class="position-relative mr-2">-->
<!--                        <div class="d-inline-flex">-->
<!--                            <input type="text" class="form-control daentreprise-groupe-recipients mr-2 border-primary"-->
<!--                                                        name="existing_member_name" id="existing_member_name">-->
<!--                                                        -->
<!--                            <a href="javascript;" role="button" class="btn btn-primary">-->
<!--                              Affecter au(x) projet(s)-->
<!--                            </a>-->
<!--                        </div>-->

<!--                        <div class="position-absolute bg-white rounded" id="daentreprise-groupe-recipient-search-result" style="max-height: 250px;overflow-y:auto;z-index:10">-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col">-->
<!--                      <select class="custom-select" style="border-color: #0049A4">-->
<!--                        <option selected>Filtre membre</option>-->
<!--                        <option>Lionel Benhammouche</option>-->
<!--                        <option>Emeline Frétigné</option>-->
<!--                        <option>Samira Elbekkaye</option>-->
<!--                        <option>Beatrice Paviot-Hidalgo</option>-->
<!--                      </select>-->
<!--                    </div>-->
                    <div class="col multiselect" id="thematiques">
                      <div class="selectBox" id="select_themes" v-on:mouseup="showCheckboxes($event)">
                        <select class="custom-select">
                          <option>Thématiques</option>
                        </select>
                        <div class="overSelect"></div>
                      </div>
                      <div class="checkboxes_multi">
                        <div v-for="tag in tags" :key="tag.id">
                          <label :for="'tag_' + tag.id">
                            <input type="checkbox"
                                   :id="'tag_' + tag.id" v-model="checked_thematiques" :value="tag.id"/>
                            {{ tag.nom }}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="col">
                        <select class="custom-select" @change="get_aaps()" v-model="status_filter">
                          <option selected @click="clear_status()">Filtre statut</option>
                          <option v-for="status in statuses" :key="status.id" :value="status.id">{{status.name}}</option>
                        </select>
                    </div>
                </div>
              </div>


              <!-- Card -->
              <div class="card card-bordered overflow-hidden m-2">

                <div class="col-12 mt-3">
                  <!-- Pagination -->
                  <div class="mt-2">
                    <dlnkpagination
                        :page="page"
                        :page_count="page_count"
                        :from="from"
                        :to="to"
                        :items_count="aaps_count"
                        :show_count="true"
                        @next_page="next_page()"
                        @prev_page="prev_page()"
                        @set_page="set_page($event)">
                    </dlnkpagination>
                  </div>
                  <!-- End Pagination -->
                </div>


                <!-- Table -->
                  <div class="table-responsive">
                    <table class="table table-borderless table-thead-bordered table-nowrap table-align-middle">
                      <thead class="thead-light">
                      <tr>
                        <th>#</th>
<!--                        <th><i class="fa fa-check-square" aria-hidden="true"></i></th>-->
                        <th classtab="px-1">Titre de l'action</th>
                        <th class="px-1">Structure</th>
                        <th class="px-1">Axe</th>
                        <th class="px-1">Statut</th>
                        <th class="px-1" style="width: 100px">Date de commission</th>
                        <th class="px-1" style="width: 100px">Montants</th>
                        <th class="px-1" style="width: 75px">Membres affectés</th>
                        <th class="px-1">Pages associées</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="aap in aaps" :key="aap.id">
                        <td class="align-middle justify-content-center px-1">
                            {{aap.id}}
                        </td>
<!--                        <td class="align-middle px-1">-->
<!--                            <input type="checkbox" id="defaultCheck1" v-bind:value="aap.id" v-model="selected_list">-->
<!--                        </td>-->
                        <td class="align-middle px-1">
                          <div class="media">
                            <img class="avatar avatar-sm avatar-circle mr-3"
                                 :src="aap.logo_structure || '/modules/dlnkaap/img/socialmedia.jpg'" alt="Logo de la structure">
                            <div class="media-body">
                              <a class="d-inline-block text-dark resume_popover" role="button" :id="'popover'+aap.id" @mousedown="enable_popover($event)"
                                 data-toggle="popover" data-trigger="focus" tabindex="-1" title="Description projet" :data-content="aap.presentation">
                                <h6 class="text-hover-primary mb-0">
                                  {{ aap.projet_nom }}
                                </h6>
                              </a>
                            </div>
                          </div>
                        </td>
                        <td class="align-middle px-1">
                          {{ aap.nom }}
                        </td>
                        <td class="align-middle px-1">
                          {{ aap.axe }}
                        </td>
                        <td class="align-middle px-1">
                          <span v-if="aap.status      === 'Brouillon'"
                                class="d-flex align-items-center badge badge-warning">Brouillon</span>
                          <span v-else-if="aap.status === 'Rempli'"
                                class="d-flex align-items-center badge badge-primary">Rempli</span>
                          <span v-else-if="aap.status === 'Instruction'"
                                class="d-flex align-items-center badge badge-primary">Instruction</span>
                          <span v-else-if="aap.status === 'Comité'"
                                class="d-flex align-items-center badge badge-primary">Comité</span>
                          <span v-else-if="aap.status === 'Assemblée'"
                                class="d-flex align-items-center badge badge-primary">Assemblée</span>
                          <span v-else-if="aap.status === 'Ajourné'"
                                class="d-flex align-items-center badge badge-primary">Ajourné</span>
                          <span v-else-if="aap.status === 'Relancé'"
                                class="d-flex align-items-center badge badge-danger">Relancé</span>
                          <span v-else-if="aap.status === 'Rejeté'"
                                class="d-flex align-items-center badge badge-danger">Rejeté</span>
                          <span v-else-if="aap.status === 'Validé'"
                                class="d-flex align-items-center badge badge-success">Validé</span>
                          <span v-else
                                class="d-flex align-items-center badge badge-info">{{aap.status}}</span>
                        </td>
                        <td class="align-middle px-1">
<!--                      TODO : N'existe pas dans la BDD-->
                          <span class="d-flex">
                            {{ aap.date_commission }}
                          </span>
                        </td>
                        <td class="align-middle px-1">
                          <p class="my-0" style="font-size: 0.75rem"><span class="font-weight-bold">Projet :</span>
                            {{ aap.budget_global }}</p>
                            <p class="my-0" style="font-size: 0.75rem"><span class="font-weight-bold">Subv. :</span>
                              {{ aap.subvention_sollicitee }}</p>
                        </td>
                        <td class="align-middle px-1">
                          <div class="dropdown">
                            <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMembers"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              Liste
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdownMembers">
                              <li class="dropdown-item">Lionel Benhammouche<i class="fa fa-times text-danger ml-1" aria-hidden="true"></i></li>
                              <li class="dropdown-item">Emeline Frétigné<i class="fa fa-times text-danger ml-1" aria-hidden="true"></i></li>
                            </ul>
                          </div>
                        </td>

                        <td class="align-middle px-1">
                          <div class="form-check form-check-inline">
                            <a :href="'/module/dlnkaap/jury_extraction?id=' + aap.id" class="btn btn-info btn-sm mr-1"
                               data-tooltip="tooltip" title="Jury">
                              <i class="fas fa-gavel fa-fw"></i>
                            </a>
                            <button type="button" class="btn btn-primary" @click="toggle_modal_note_jury(aap)"
                                    data-tooltip="tooltip" title="Note du jury">
                              <i class="fas fa-book fa-fw"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- End Table -->

                
              </div>
              <!-- End Card -->


            </div>
            <!-- End Card -->
          </div>
        </div>
        <!-- End Row -->
      </div>
      <!-- End Content Section -->
    </main>
    <!-- ========== END MAIN ========== -->


    <!-- Encadré fixe pour le montant des projets selectionnés -->
<!--    <div v-if="selected_list.length > 0" class="border-1" style="position: fixed; top: 120px; right:35px; z-index: 10">-->
<!--        <div class="card bg-secondary p-2">-->
<!--          <p class="text-center text-white h5 mb-2">Totaux <br> (sélection) : </p>-->
<!--          <p class="text-center text-white h6 font-weight-normal mb-2">Budget : 23456€</p>-->
<!--          <p class="text-center text-white h6 font-weight-normal mb-2">Subv. : 12345€</p>-->
<!--        </div>-->
<!--    </div>-->


  </div>

</template>


<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  props: {},
  data: function () {
    return {
      message: "",
      message_type: "",

      wait_data: true,

      customer: Object,
      aaps: Array,
      tags: Array,
      selected_list: [],

      current_aap: {},
      montant_total: Number,
      montant_restant: Number,
      montant_alloue: Number,
      note_jury: "",
      statuses: Array,
      page: 1,
      page_count: 0,
      status_filter: [1,2],
      show_archived: false,
      show_deleted: false,
      query: "",
      checked_thematiques: [],

      expanded: false,
      currentSelect: "",

      editor: ClassicEditor,
      editor_config: {
        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo' ],
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
          ]
        }
      },
    }
  },
  mounted() {
    this.montant_total = 0
    this.montant_restant = 0
    this.get_data()
  },

  updated(){

  },

  created: function () {
    window.addEventListener('mousedown', this.mouseDownEvent);
  },
  destroyed: function () {
    window.removeEventListener('mousedown', this.mouseDownEvent);
  },

  computed: {},

  watch: {

    checked_thematiques: function (new_val, old_val) {
      this.get_data()
    },

    query: function (new_val, old_val) {
      if (new_val.length > 2) {
        this.get_data()
      }
    },

    page: function (new_val, old_val) {

      if (new_val < 1) {
        this.page = 1
      }

      if (new_val > this.page_count) {
        this.page = this.page_count
      }

      this.get_data()
    },


  },

  methods: {

    mouseDownEvent: function (event) {
      if (this.expanded) {
        var multiSelect = document.getElementById(this.currentSelect).nextElementSibling;
        if (!multiSelect.contains(event.target)) {
          //On a cliqué en dehors du select
          multiSelect.style.display = "none";
          this.expanded = false;
        }
      }
    },

    close_message: function () {
      this.message = null;
    },

    set_page: function (page) {
      page = parseInt(page)
      this.page = page
    },

    next_page: function () {
      this.page++
    },

    prev_page: function () {
      this.page--
    },

    destroy: async function (id) {
      const _this = this;
      if (confirm("Êtes vous certain de vouloir supprimer cette candidature ?")) {
        let [secure_key, customer_id, api_url, customer] = await get_token_2()
        api_url += "aaps/" + id + ".json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.delete(api_url)
            .then(function (response) {
              _this.get_data()
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
                  // always executed
                }
            );
      }
    },

    get_data: function () {
      this.get_aaps()
      this.get_tags()
      this.get_montant_total()
      this.get_date_commission()
      this.get_statuses()
    },

    get_montant_total: async function() {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `configs/DLNK_AAP_MONTANT_TOTAL.json`
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.montant_total = parseInt(response.data.config.value, 10)
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );

    },

    get_date_commission: async function() {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `configs/DLNK_AAP_DATE_COMMISSION.json`
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.montant_total = parseInt(response.data.config.value, 10)
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );

    },

    clear_status: function () {
      this.status_filter = [1,2]
      this.get_aaps()
    },

    get_aaps: async function () {
      const _this = this;
      _this.wait_data = true
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      api_url += '&page=' + _this.page
      api_url += '&status=' + _this.status_filter
      api_url += '&tags=' + _this.checked_thematiques
      if(_this.query.length > 2) {
        api_url += '&search=' + _this.query
      }


      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.aaps = response.data.aaps
            _this.montant_alloue = parseInt(response.data.meta.montant_alloue, 10)
            _this.montant_restant = _this.montant_total - _this.montant_alloue
            _this.page = response.data.meta.page
            _this.page_count = response.data.meta.pages
            _this.aaps_count = response.data.meta.count
            _this.from = response.data.meta.from
            _this.to = response.data.meta.to
            _this.wait_data = false
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_tags: async function () {
      let _this = this
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aap_tags.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.tags = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    set_note: async function () {
      const _this = this;
      _this.wait_data = true
      const id = _this.current_aap.id
      const form_data = new FormData()
      form_data.append('aap[note_jury]', _this.note_jury)

      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += `aaps/${id}.json`
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'patch',
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.get_aaps()
            $('#notes_modal').modal('hide')
            _this.message = "Note enregistrée"
            _this.message_type = "alert-success"
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                _this.wait_data = false
              }
          );
    },

    get_statuses: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aaps/statuses.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.statuses = response.data.statuses
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    toggle_modal_note_jury: function (aap) {
      this.current_aap = aap
      this.note_jury = aap.note_jury
      // const modal = document.getElementById('notes_modal')
      $('#notes_modal').modal('show')
    },

    enable_popover: function(event){
      $('#'+event.currentTarget.id).popover('enable');
    },

    showCheckboxes: function (event) {
      var checkboxes = event.target.parentElement.nextElementSibling;
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
        this.currentSelect = event.target.parentElement.id;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
    },
  }
}

</script>
